var advancedAddIdsToResults = true;

// namespace utils

var utils = {};

// get unique values out of array of object

export function getUniqueValue(data, fieldname){

  if (typeof data == 'undefined' || data.length==0 )
    return [];

  return  Array.from( new Set( data.map( item => item[fieldname] ) ) );
}


// coalesce, for getting the first valid value in a array to choose from

export function coalesce(arr){

      for (var i=0; i<arr.length; i++)
      {
        if (typeof arr[i] != 'undefinied' && arr[i] != null)
        return arr[i];
      }
      return '';
  };


// regex version of indexOf

export function regexIndexOf(str, regex, startpos) {      
    var indexOf = str.substring(startpos || 0).search(regex);
    return (indexOf >= 0) ? (indexOf + (startpos || 0)) : indexOf;
};


  // we need this function so as to render READABLE data, when that consists of long URIs whereas we only need the last part of thoses
  // like http://dit.en.dat/in.domein.weet.ik.veel/eigenschap, and we only need 'eigenschap'

export function formatThat(str) {

    // null or so, leave straight away!
    if (typeof str == 'undefined' || str == null)
      return '';

    // if the string isn't a URL, leave right away
    if (str.indexOf("http:")<0)
      return str;
    
    // cut off the URL prefix!
    var lastSlash = str.lastIndexOf("/");
    var lastHash = str.lastIndexOf("#");
    //var lastUnderscore = str.lastIndexOf("_");
    var allInArray = [lastSlash, lastHash]; //, lastUnderscore];
    allInArray.sort();
    var cutOfFrom = allInArray[allInArray.length-1];

    if (cutOfFrom>-1) 
      str = str.substring(cutOfFrom+1);             

  return str;
};


// add highlight code to a string

export function highlightThis(keyword, str){

    if (typeof str == 'undefined' || str == null)
        return '';

    // clean keyword to be able to match and highlight:
    //  get rid of wild cards
    //  get rid of groups (...)
    //  get rid of enums [...]
    //  get rid of +/* put after groups or enums
    var cleanKeyword = keyword.replace(/[\^\$]/g, '').replace(/\(.+?\)/g, '').replace(/\[.+?\]/g, '').replace(/[\+*]/g, '');

    // highlighter
    str = str.replace(`${cleanKeyword}`, `<span style="background-color: yellow">${cleanKeyword}</span>`);
    return str;
  };



// check if some string contains a regex like '^(...|...|...)$'
export function isFullMatchRegex(regexStr){

  return (new RegExp("^\\^\\(.+\\)\\$$")).test(regexStr);
  
}

// convert a string consisting of a regex like '^(...|...|...)$' into a clean list of seperate values
// like '{ "..."@nl "..." }'

export function convertRegexIntoSeperateValues(regexStr){

  // remove '^(' and ')$' from regex
  var regexArr = (regexStr.replace(/^\^\(/, "").replace(/\)\$$/, "")).split("\|");

  var output1 = '"'+regexArr.join('"@nl "')+'"@nl';
  //var output2 = '"'+regexArr.join('" "')+'"';

  //return "{ "+output1+" "+output2+"} ";
  return "{ "+output1+" } ";
}


export function containsRegex(searchTerm){
    return searchTerm.indexOf('|')>-1 || searchTerm.indexOf('^')>-1 || searchTerm.indexOf('$')>-1 || searchTerm.match(/\(.+?\)/g) || searchTerm.match(/\[.+?\]/g) || searchTerm.match(/[\+*]/g);
  };

export function hasNoEmptyValue(someVariable){

    return (typeof someVariable != 'undefined' && someVariable != null && someVariable != '');
  };

// https://stackoverflow.com/questions/9907419/how-to-get-a-key-in-a-javascript-object-by-its-value
export function getKeyByValue(object, value) {

  return Object.keys(object).find(key => object[key] === value);
};


// remove the '(?lemId AS ?colorId)' part of queries
export function removeColorIdColumn(queryStr){

  queryStr = queryStr.replace(/\(.+? as \?colorid\)/i , "");

  return queryStr;
}

export default utils;


// WEBPACK FOOTER //
// ./src/js/utils.js